export const sharePath = [
    {
        path: "/share/home",
        component: () => import(/* webpackChunkName: "home" */ './Home/index.vue'),
        meta: {
            title: '首页'
        }
    }, {
        path:"/share/demo/:id",
        component: () => import(/* webpackChunkName: "demo" */ './Demo/index.vue'),
        meta: {
            title: '演示页',
            key:''
        }
    }
]